module.exports = __webpack_public_path__ + "img/hkht.e2ec964.png";